export const JWT_CUSTOM_CLAIMS = 'https://hasura.io/jwt/claims';
export const DEFAULT_ROLE_CUSTOM_CLAIM = 'x-hasura-default-role';
export const ALLOWED_ROLES_CUSTOM_CLAIM = 'x-hasura-allowed-roles';

export const HASURA_USER_STORAGE_KEY = 'hasura:user';
export const ACTIVE_SUB_ACCOUNT_ID_KEY = 'hasura:active-sub-account-id';
export const MAIN_ACCOUNT_INFO_KEY = 'hasura:main-account-info-id';
export const HIDE_CONNECT_FULLSCRIPT_BANNER =
  'hasura:hide-connect-fullscript-banner';
export const HIDE_ADD_CHILD_BANNER = 'hasura:add-child-banner';
export const SHOW_VERIFY_EMAIL_TOST = 'show-verify-email-toast';

export const LAST_REQUEST = 'last-request';
